<template>
  <div class="chat_box">
    <div class="prof seller">
      <div class="inner">
        <img
          src="@/assets/front/images/v2/profiles/img_perce_prof_w.png"
          alt=""
        />
      </div>
    </div>
    <div class="chat_con perce_chat_con">
      <div class="chat_txt">
        <div class="chat_system_notice">
          <i class="i_chat_notcie"></i>
          매장에서 가입신청서를 열람하였습니다.
        </div>
        <div
          class="chat_msg system"
          v-if="isType == 'INTERNET_VOUCHER_OPEN_NOTICE'"
        >
          매장과의 상담은 즐거우셨나요?<br />
          상담이 만족스러웠다면 매장리뷰를 작성하여 경험을 공유해주세요!
        </div>
        <div
          class="chat_msg system"
          v-if="isType == 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE'"
        >
          본인인증 후에 매장에게 말씀해주시면 가입신청이 완료됩니다.
        </div>
      </div>
      <button
        v-if="isType == 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE'"
        class="chat_txt_btn"
        @click="
          openSelfIdenModal(
            'https://online.kt.com/smart/simple/simpleCustomerInfoPop.do?prdcId=F5D84AAF-D8CB-4C65-A0F5-824A620852E7',
          )
        "
      >
        <i class="i_chat_write_form"></i>본인 인증하기 (PASS,카드인증)
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatRoomInternetVoucherOpen',
  description: '인터넷 가입신청서 열람 시스템 메세지',
  props: {
    isCustomer: Boolean,
    isType: String, // INTERNET_VOUCHER_OPEN_NOTICE, INTERNET_PROMOTION_OPEN_KT2408_NOTICE
  },
  methods: {
    openSelfIdenModal(url) {
      this.$emit('openSelfIdenModal', url);
    },
  },
};
</script>

<style></style>
